module.exports = __webpack_public_path__ + "img/m_bg_02.a9dc6ec6.svg";